module.exports = __webpack_public_path__ + "media/images/job_list/icon_bridal_02-e25773c0b9c60bdfef99281bbf47f387.png";